import gql from 'graphql-tag'

export const getRelatedProducts = gql`
  query getRelatedProducts($productId: Int, $relatedItemTag: String) {
    products: getRelatedProducts(id: $productId, relatedTag: $relatedItemTag) {
      id
      type: name
      code
      name
      serie
      active
      description: short_description
      images: pictures2 {
        thumbnail
        front: front_image
      }
      customizable: design_center
      priceRange {
        price
        quantity
        abbreviation
        shortName: short_name
      }
    }
  }
`

export const getRelatedDesigns = gql`
  query getRelatedDesigns($designId: String!) {
    designs: getRelatedDesigns(designId: $designId) {
      shortId: short_id
      code
      image
      name
      product {
        id
        type: name
        code
        name
        description: short_description
        customizable: design_center
        genders {
          id
          name: gender
        }
        priceRange {
          price
          quantity
          abbreviation
          shortName: short_name
        }
      }
    }
  }
`

export const getSingleTeamStore = gql`
  query getTeamStore(
    $teamStoreId: String!
    $passCode: String
    $date: HolyDate
    $limit: Int
    $offset: Int
    $skipCode: Boolean
  ) {
    getTeamStore(
      teamStoreId: $teamStoreId
      passCode: $passCode
      storeFront: true
      date: $date
      limit: $limit
      offset: $offset
      isInfinite: true
      skipCode: $skipCode
    ) {
      id
      short_id
      name
      banner
      private
      bulletin
      isResellerStore
      owner
      featured
      owner_name
      display
      fixedPrice: fixed_price
      onDemandMode: on_demand_mode
      team_size_id
      closed
      priceRanges {
        id
        name: quantity_description
      }
      cutoff_date {
        day
        dayOrdinal
        month
      }
      delivery_date {
        day
        dayOrdinal
        month
      }
      items {
        id
        expected_quantity
        visible
        short_id
        isInline: is_inline
        priceRange {
          price
          shortName: short_name
          quantity
          abbreviation
        }
        resellerRange {
          price
          shortName: short_name
          quantity
          abbreviation
        }
        design {
          id
          code
          name
          image
          shortId: short_id
          proDesign: pro_design
          proCertified: pro_certified
          product {
            id
            code
            yotpoId: yotpo_id
            name
            active
            type: name
            customizable: design_center
            hasInventory: has_inventory
            inventoryJson: inventory_json
            colorGenders: color_genders
            onlyProDesign: only_pro_design
            description: short_description
            hideFitStyles: hide_fit_styles
            sizeTag: size_tag
            youthCombined: youth_combined
            shortDescription: short_description
            collections
            isTopProduct
            weight
            twoPieces: two_pieces
            genders {
              id
              name: gender
            }
            fitStyles {
              id
              info
              name: description
            }
            priceRange {
              quantity
              price
              abbreviation
              shortName: short_name
            }
            sizeRange: size_range {
              id
              name
              isYouth: is_youth
            }
            colors {
              id
              name
              image
            }
          }
        }
        totalOrders
      }
    }
  }
`

export const getKitGalleryQuery = gql`
  query getKitGallery($ids: [Int]!) {
    products: getKitGallery(ids: $ids) {
      id
      type: name
      code
      name
      serie
      description: short_description
      images: pictures2 {
        thumbnail
        front: front_image
      }
      onlyProDesign: only_pro_design
      customizable: design_center
      priceRange {
        price
        quantity
        abbreviation
        shortName: short_name
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/YotpoSection/data.ts